import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="container-pad mx-auto max-w-[1100px] py-16 md:py-24" data-testid="about-page">
      <span className="label-eyebrow">About FinSahayak</span>
      <h1 className="mt-3 text-4xl sm:text-5xl font-display font-medium tracking-tighter text-[#121C17]">Compliance with a human heart.</h1>
      <p className="mt-6 text-lg text-[#5C6661] leading-relaxed max-w-3xl">
        FinSahayak was started in 2021 by a small team of chartered accountants and product designers who were tired of how opaque, slow and intimidating compliance felt for Indian small businesses. We exist to fix that — with transparent pricing, real human chat, and a process that respects your time.
      </p>

      <div className="mt-12 grid md:grid-cols-3 gap-4">
        {[
          { v: "2021", l: "Founded in Bengaluru" },
          { v: "25,000+", l: "MSMEs served" },
          { v: "350+", l: "CAs & lawyers" },
        ].map((s) => (
          <div key={s.l} className="bento-card p-7">
            <div className="text-3xl font-display font-medium text-[#1E4D3B]">{s.v}</div>
            <div className="text-sm text-[#5C6661] mt-2">{s.l}</div>
          </div>
        ))}
      </div>

      <img src="https://images.unsplash.com/photo-1599978395458-d4ce49ea5e56?crop=entropy&cs=srgb&fm=jpg&w=1400" alt="Indian business owner" className="mt-16 w-full rounded-2xl object-cover h-[280px] md:h-[420px]" />

      <h2 className="mt-16 text-3xl font-display font-medium tracking-tight text-[#121C17]">What drives us</h2>
      <div className="mt-6 grid md:grid-cols-2 gap-4">
        {[
          { t: "Clarity over jargon", d: "Every quote, every status, in plain language." },
          { t: "Speed without shortcuts", d: "We sprint on response time. We don't sprint on accuracy." },
          { t: "Human first", d: "There's always a real CA on chat. No bots pretending to be people." },
          { t: "Pricing that respects you", d: "No hidden fees, no surprises. Start from ₹99." },
        ].map((v) => (
          <div key={v.t} className="bento-card p-7">
            <h3 className="text-lg font-display font-medium text-[#121C17]">{v.t}</h3>
            <p className="mt-2 text-[#5C6661] text-sm leading-relaxed">{v.d}</p>
          </div>
        ))}
      </div>

      <div className="mt-16">
        <Link to="/services" data-testid="about-cta" className="btn-primary rounded-full px-6 py-3 text-sm font-medium">Browse our services</Link>
      </div>
    </div>
  );
}
